// ── EVENT CONFIG ──────────────────────────────────────────────
// Departure date/time for Dunderkryssningen. Update this to the real
// departure date. Format: ISO 8601 with timezone offset (Swedish time).
export const EVENT_DEPARTURE = "2026-11-13T17:00:00+01:00";

export const EVENT_NAME = "Dunderkryssningen";
export const EVENT_YEAR = "2026";
export const EVENT_TAGLINE = "Sveriges fetaste hemmafest, fast på vatten";
export const SITE_URL = "https://dunderkryssningen.se";

export const SILJA_LINE_URL =
  "https://www.tallink.com/sv/hitta-resa/kryssning/specialkryssningar/dunderkryssningen";

// Shared brand assets
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_nordic-cruise-launch/artifacts/ae74l9ew_DUNDER%20LOGO%20SMOKE.png";
export const DUNDERTJEJ_URL =
  "https://customer-assets.emergentagent.com/job_nordic-cruise-launch/artifacts/6qj0p6wr_Dundertjej-2nyast%20%281%29.png";
export const DUNDER_GUBBE_2026_URL =
  "https://customer-assets.emergentagent.com/job_nordic-cruise-launch/artifacts/iqfqlba9_Dunder2026-gubbe.png";
